<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                <el-form label-position="top">
                    <el-form-item label="筛选学校">
                        <el-select v-model="filter.school_id" clearable placeholder="请选择学校" filterable remote
                                   :remote-method="handleSearchSchool" @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in schools"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选年级">
                        <el-select v-model="filter.grade_id" clearable placeholder="请选择年级" @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选班主任">
                        <el-select v-model="filter.headTeacher_id" clearable placeholder="请选择班主任" filterable remote
                                   :remote-method="handleSearchHeadTeacher" @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in headTeachers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选学期有课学生">
                        <el-select v-model="filter.semester_id" placeholder="请选择学期" @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in semesters"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选是否有班主任的学生">
                        <el-select v-model="filter.hasHeadTeacher" clearable placeholder="是否有班主任的学生"
                                   @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in hasHeadTeacherStudents"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="特殊筛选">
                        <el-select v-model="filter.specialChoose"
                                   multiple
                                   clearable
                                   placeholder="请选择"
                                   @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in specialTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="m-portlet right m-b-0">
            <div class="m-portlet__body" :style="{'height':clientHeight-96-61.59+'px'}" v-loading="loading">
                <el-table v-if="!loading"
                          :data="orderStudents"
                          style="width: 100%"
                          :height="clientHeight-96-61.59-2.2-2-13-20"
                          size="middle">
                    <el-table-column prop="id" label="学号" min-width="5%"></el-table-column>
                    <el-table-column prop="name" label="姓名" min-width="10%"> </el-table-column>
                    <el-table-column label="学校" min-width="10%">
                        <template slot-scope="scope">
                            <span v-if="scope.row.current_education.length!=0">{{scope.row.current_education.school.name}}</span>
                            <span v-else>学校未添加</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="年级" min-width="5%">
                        <template slot-scope="scope">
                            <span v-if="scope.row.current_education.length!=0">{{scope.row.current_education.grade.name}}</span>
                            <span v-else>年级未添加</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="phone" label="学生联系方式" min-width="10%"></el-table-column>
                    <el-table-column label="家长姓名" min-width="15%">
                        <template slot-scope="scope">
                            <p v-for="parent in scope.row.parents" :key="parent.id">
                                <span>{{parent.parent_identity}}： {{parent.name}}</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="家长联系方式" min-width="10%">
                        <template slot-scope="scope">
                            <p v-for="parent in scope.row.parents" :key="parent.id">
                                <span>{{parent.phone}}</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="班主任" min-width="10%">
                        <template slot-scope="scope">
                            <span v-for="(headTeacher,index) in scope.row.headTeachers" :key="index"> {{headTeacher.name}} </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_account" label="是否有账号" min-width="10%">
                    </el-table-column>
                    <el-table-column label="操作" v-if="powers.includes(2)" min-width="10%">
                    <!--<el-table-column label="操作">-->
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleStudentInformation(scope.row.id,scope.row.name)">查看详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    // import store from '@/store'

    export default {
        name: "students-list",
        data() {
            return {
                path: '/student/list',
                loading: true,
                students: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                semesters: [],
                headTeachers: [],
                schools: [],
                grades: [],

                hasHeadTeacherStudents: [
                    {
                    value: '1',
                    label: '有班主任的学生'
                }, {
                    value: '0',
                    label: '没有班主任的学生'
                }],
                specialTypes:[
                    {
                        value: '1',
                        label: '正常'
                    },
                    {
                        value: '2',
                        label: '已退'
                    },
                    {
                        value: '3',
                        label: '试听'
                    },
                    {
                        value: '4',
                        label: '购物车'
                    }
                ],

                filter:{
                    grade_id: '',
                    school_id: '',
                    headTeacher_id: '',
                    confirmStudent: '',
                    hasHeadTeacher: '',
                    specialChoose:[],
                }
            }
        },
        props: {},
        components: {},
        created() {
            this.handleInit();
            this.handleIndexStudent();
            this.handleCreate();

        },
        beforeDestroy(){
            this.$wApi.removeListen(this.path)
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            orderStudents: function () {
                return this._.values(this.students);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.semesters = data.semesters;
                        this.grades = data.grades;
                        this.schools = data.schools;
                        this.headTeachers =  data.headTeachers;
                        break;
                    case 'list':
                        if (Object.keys(data.students).length > 0) {
                            this.students = data.students;
                        } else {
                            this.students = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'searchSchool':
                        this.schools = data.searchData;
                        break;
                    case 'searchHeadTeacher':
                        this.headTeachers = data.searchData;
                        break;
                }
            },
            handleInit() {
                this.$wApi.send(this.path, 'init', {})
            },
            handleIndexStudent(currentPage=1) {
                if (currentPage===1){
                    this.currentPage=1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': this.currentPageSize,
                    'filter': this.filter,
                });
            },
            handleSearchSchool(query) {
                this.$wApi.send(this.path, 'search', {
                    'type':'searchSchool',
                    'schoolKeyName': query,
                })
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.path, 'search', {
                    'type':'headTeacherKeyName',
                    'headTeacherKeyName': query,
                })
            },

            handleStudentInformation(student_id, title) {
                this.$store.dispatch('addView', {
                    'title': title,
                    'path': '/student/' + student_id,
                    'closable': true
                });
                this.router.push({path: '/student/' + student_id})
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexStudent(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexStudent(this.currentPage)
            },

        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }
</style>
